export default {"src":"/_next/static/media/chevron-left-white.96ec71a1.svg","height":14,"width":8};